import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseURL } from "services/api";
import { Region, UserRegionsResponse } from "./types";

const baseQuery = fetchBaseQuery({
  baseUrl: `${baseURL}/region`,
  prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    const token = localStorage.getItem("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    }
    return headers;
  },
});

export const regionApi = createApi({
  reducerPath: "regionService",
  baseQuery,
  endpoints: (builder) => ({
    getRegions: builder.query<Region[], null>({
      query: () => "/",
    }),
    getUserRegions: builder.query<UserRegionsResponse, null>({
      query: () => "/user",
    }),
  }),
});

export const { useGetRegionsQuery, useGetUserRegionsQuery } = regionApi;
